import { render, staticRenderFns } from "./CalendarOverview.vue?vue&type=template&id=0cbd794c"
import script from "./CalendarOverview.vue?vue&type=script&lang=js"
export * from "./CalendarOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports